<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasWinoWino" aria-labelledby="offcanvasWinoWinoLabel">
    <div class="offcanvas-header">
        <p class="offcanvas-title text-primary fs-4" id="offcanvasWinoWinoLabel">{{headerLabel}}</p>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <ng-content></ng-content>
    </div>
</div>
